import React from "react";
import Modal from 'react-responsive-modal';
import planeImage from '../../imgs/plane-reverse.png';

import { Link, Switch, Route } from 'react-router-dom'

import $ from 'jquery';

import Plane1 from './../docs/Plane-1.js'
import Plane2 from './../docs/Plane-2.js';

// Icons

import soundwave from '../../icons/soundwave.svg';
import airplane from '../../icons/airplane.svg';

export default class extends React.Component {
  constructor(props) {
      super(props);
      this.state = {
          open : false,
          modalContentOpen: false,
      }
  }


  onOpenModal = () => {
    this.setState({ open: true });
    $.fn.fullpage.setMouseWheelScrolling(false);
    $.fn.fullpage.setAllowScrolling(false);
    console.log('hi girls');
  };

  onCloseModal = () => {
    this.setState({ open: false });
    $.fn.fullpage.setMouseWheelScrolling(true);
    $.fn.fullpage.setAllowScrolling(true);
  };

  onOpenContentModal = () => {
    this.setState({modalContentOpen: true})
  }

  onCloseContentModal = () => {
    this.setState({modalContentOpen: false})
  }
  render() {
    return (
      <section className="plane section">
      <div className="row center-xs center-sm">
        <div className="col-xs-12 col-md-6 col-sm-6 col-lg-6">
          <div className="container">
            <div className="row center-xs start-lg start-sm start-md">
              <div className="col-xs-6 col-md-6 col-lg-6 col-sm-6">
                <h1 className="heading">Самолёт</h1>
                <h2 className="subheading">Самолёт — воздушное судно, предназначенное для полётов в атмосфере с помощью силовой установки, создающей тягу, и неподвижного, относительно других частей аппарата крыла, создающего подъёмную силу.</h2>
                <Link to=''>
                  <div onClick={this.onOpenModal} className="button">
                    <span className="button__mask"/>
                    <span className="button__text">Открыть</span>
                    <span className="button__text button__text--bis">Открыть</span>
                  </div>
                </Link>
                <Modal open={this.state.open} onClose={this.onCloseModal} little styles={
                  {
                    modal: {
                      padding: '2em',
                    }
                  }
                }>
                <div className='row center-xs modal'>
                  <div className='col-xs-6'>
                    <Link onClick={this.onOpenContentModal} className='link' to='/Plane-1'>
                      <img alt='' className='responsive-icon' src={soundwave} />
                      <p className='icon-heading'>Звуковой барьер</p>
                    </Link>
                  </div>
                  <div className='col-xs-6'>
                    <Link onClick={this.onOpenContentModal} className='link' to='/Plane-2'>
                      <img alt='' className='responsive-icon' src={airplane} />
                      <p className='icon-heading'>Сверхзвуковая гражданская авиация</p>
                    </Link>
                  </div>
                </div>
                </Modal>
                  <Modal open={this.state.modalContentOpen} onClose={this.onCloseContentModal}>
                    <Switch>
                    <Route exact path='/Plane-1' component={Plane1}/>
                    <Route exact path='/Plane-2' component={Plane2}/>
                  </Switch>
                  </Modal>
              </div>
              <div className="col-xs-12 col-md-6 col-sm-6 col-lg-6">
                <img className="plane-img" src={planeImage} alt="alt"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
  }
}



// WEBPACK FOOTER //
// ./src/components/sections/Plane.js